import { tr } from 'i18n';
import $api from "http";

export const getErpUsers = (params) => $api.get("/account/users/", { params });
export const createErpUser = (data) => $api.post("/account/users/", data);
export const checkErpInn = (inn) => $api.get("/account/users/inn-availability/", { params: { inn } });
export const updateErpUser = (id, data) =>
  $api.patch(`/account/users/${id}/`, data);
export const getAuditEvents = (params) =>
  $api.get("/account/audit/", { params });
export const getAccessOptions = () => $api.get("/account/access-options/");

export function getErpErrorMessage(
  error,
  fallback = tr("Не удалось выполнить действие."),
) {
  const data = error?.response?.data;
  const messages = (value) => {
    if (typeof value === "string") return value.trim() ? [tr(value)] : [];
    if (Array.isArray(value)) return value.flatMap(messages);
    if (value && typeof value === "object")
      return Object.values(value).flatMap(messages);
    return [];
  };
  if (typeof data === "string" && (data.length > 700 || /<!doctype|<html|<head|<body/i.test(data)))
    return fallback;
  const selected =
    data && !Array.isArray(data) && typeof data === "object"
      ? data.detail ||
        data.error ||
        data.non_field_errors ||
        data.message ||
        data
      : data;
  return messages(selected).join(" · ") || fallback;
}
